import { RawTeacherClass, TeacherClass, TeacherClassesResponse } from './types';

const renameDuplicateNames = (classes: TeacherClass[] = []) => {
  const nameMapping: Record<string, number[] | undefined> = {};

  classes.forEach((classObj, idx) => {
    nameMapping[classObj.displayName] = nameMapping[classObj.displayName]
      ? (nameMapping[classObj.displayName] ?? []).concat([idx])
      : [idx];
  });

  return classes.map((classObj, idx) => {
    const nameIndexes = nameMapping[classObj.displayName];
    const displayName =
      nameIndexes?.length === 1
        ? classObj.displayName
        : `${classObj.displayName} (${(nameIndexes?.indexOf(idx) ?? 0) + 1})`;

    return Object.assign({}, classObj, { displayName });
  });
};

const addDisplayNamePropToClasses = (
  classes: RawTeacherClass[],
): TeacherClass[] => {
  return classes.map((classObj) => {
    const metadataDisplayName = (classObj.metadata?.displayName ?? '').trim();
    const displayName = !metadataDisplayName
      ? classObj.title
      : metadataDisplayName;
    return Object.assign({}, classObj, { displayName });
  });
};

export const normalizeTeacherClassesResponse = (
  response: TeacherClassesResponse,
): TeacherClass[] => {
  const classes = response.classes ?? [];

  return renameDuplicateNames(addDisplayNamePropToClasses(classes));
};
